import React from "react";
import { IMachine as Machine } from "../../../interfaces";
import { ReactComponent as Calendar } from "../../../assets/date.svg";

const InfosMachine: React.FC<{ machine: Machine; isListInView1: boolean }> = ({
  machine,
  isListInView1,
}) => {
  return (
    <div className={` flex flex-col flex-1 ${isListInView1 ? "mr-6" : ""}`}>
      {/* <div
        className={`flex items-center justify-between ${
          isListInView1 ? "mb-1" : "mb-2"
        }`}
      >
        <span className="block  dark:text-slate-200">
          {machine.Name}
        </span>
      </div>
      <p
        title={machine.machineId}
        className={`description mb-2 text-slate-500 dark:text-slate-500 ${
          isListInView1 ? "line-clamp-2 sm:line-clamp-1" : "line-clamp-3"
        }`}
      >
        {machine.machineId}
      </p>
      <p
        title={machine.description}
        className={`description mb-2 text-slate-500 dark:text-slate-500 ${
          isListInView1 ? "line-clamp-2 sm:line-clamp-1" : "line-clamp-3"
        }`}
      >
        {machine.description}
      </p>
      <time className="mt-auto flex w-full">
        <Calendar className="mr-2 w-4 sm:w-5" /> {machine.date}
      </time> */}

      <ul className="divide-y divide-[#747474] dark:divide-[#747474]" >
            <li className="py-2 sm:py-2">
              <div className="flex items-center">
                <div className="flex-1 min-w-0 ms-4">
                  <p className="text-sm  text-gray-900 truncate dark:text-white">
                    User Name
                  </p>
                  <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                  {machine.Name}
                  </p>
                </div>
                
              </div>
            </li>

            <li className="py-2 sm:py-2">
              <div className="flex items-center">
                <div className="flex-shrink-0"></div>
                <div className="flex-1 min-w-0 ms-4">
                  <p className="text-sm  text-gray-900 truncate dark:text-white">
                    Machine Id
                  </p>
                  <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                  {machine.machineId}
                  </p>
                </div>
                
              </div>
            </li>

            <li className="py-2 sm:py-2">
              <div className="flex items-center">
                <div className="flex-shrink-0"></div>
                <div className="flex-1 min-w-0 ms-4">
                  <p className="text-sm  text-gray-900 truncate dark:text-white">
                    Active Strategies
                  </p>
                  <p title={machine.ApplicationName} className="text-sm text-gray-500 truncate dark:text-gray-400">
                  {machine.ApplicationName}
                  </p>
                </div>
                
              </div>
            </li>

            <li className="py-2 sm:py-2">
              <div className="flex items-center">
                <div className="flex-shrink-0"></div>
                <div className="flex-1 min-w-0 ms-4">
                  <p className="text-sm  text-gray-900 truncate dark:text-white">
                    Email
                  </p>
                  <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                  {machine.Email}
                  </p>
                </div>
                
              </div>
            </li>

            <li className="py-2 sm:py-2"> 
              <time className="mt-auto flex text-black w-full">
                <Calendar className="mr-2 w-4 sm:w-5" /> {machine.date}
              </time>
            </li>
          </ul>
     
    </div>
  )
}

export default InfosMachine;
